import { buildM365ChatUrl, type Prompt } from "@1js/pl-card-components";
import { type HandoffCallbackResult } from "../hooks/handoff.types";

export type M365Destination = "M365Chat" | "Teams";

/**
 * Handles handoff to M365 Chat service, to try prompts in M365 Chat, or Teams.
 * @param promptText - The prompt command text to handoff
 * @param _destination - The destination product or service to handoff the prompt to
 * @param onSuccess - The callback to call when handoff is successful
 * @param onError - The callback to call when handoff fails
 */
export const handoffToM365Chat = (
  prompt: Prompt,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _destination: M365Destination
): Promise<HandoffCallbackResult> => {
  const handoffUrl = buildM365ChatUrl(
    prompt,
    "tryInApp",
    undefined,
    false,
    true
  );
  const reference = window.open(handoffUrl);

  if (!reference) {
    throw new Error("PopupBlocked");
  }

  return Promise.resolve({ handoffUrl });
};
